export enum LocalStorageEnums {
  // local storage key for bearer token
  TOKEN_KEY = 'ess-token',
  // local storage key for refresh token
  REFRESH_TOKEN_KEY = 'ess-refresh-token',
  // local storage key for the user preferences' language
  LANGUAGE_KEY = 'ess-language',
  // local storage key for the user preferred theme mode (light / dark)
  THEME_MODE = 'theme-mode',
  // local storage key to hide or not the new ess banner
  ESS_BANNER_HIDDEN = 'ess-banner-hidden',
  // local storage key for region
  APP_REGION = 'ess-app-region',
  // local storage key for timesheet recent departments
  TIMESHEET_RECENT_DEPARTMENTS = 'timesheet-recent-departments',
  // local storage key for timesheet recent jobs
  TIMESHEET_RECENT_JOBS = 'timesheet-recent-jobs',
  // local storage key for logged in with SSO
  LOGGED_IN_WITH_SSO = 'ess-has-logged-in-with-sso',
  // local storage key for brand config settings most be same as mss
  BRAND_CONFIG_SETTINGS = 'brand-config-settings',
}
